import * as React from "react";
import { Check } from "lucide-react";

import { cn } from "@/lib/utils";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "./ui/command";

import { ScrollArea } from "./ui/scroll-area";

import FlexiblePopover from "./flexible-popover";
import { dir } from "i18next";
import { useLocale, useTranslations } from "next-intl";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/redux/store";
import { setSearchParams } from "@/redux/slices/searchParams.slice";
import CircularProgress from "./CircularProgress";

export default function CitiesCombobox({
  list,
  placeholder,
  searchPlaceholder,
  isLoading,
}: {
  list: { value: string; label: string }[];
  placeholder: string;
  searchPlaceholder: string;
  isLoading?: boolean;
}) {
  const [open, setOpen] = React.useState(false);
  const q = useSelector((state: RootState) => state.searchParams);
  const dispatch = useDispatch();
  const locale = useLocale();
  const t = useTranslations();

  return (
    <FlexiblePopover
      open={open}
      onOpenChange={setOpen}
      placeholder={placeholder}
      header={list
        ?.filter((city) => q?.cityId?.includes(city.value))
        .map((city) => city.label)
        .join("، ")}
    >
      <Command>
        <CommandInput placeholder={searchPlaceholder} />
        <CommandList>
          <CommandEmpty>
            {isLoading ? (
              <CircularProgress size="sm" />
            ) : (
              t("citiesCombobox.noResults")
            )}
          </CommandEmpty>
          <ScrollArea dir={dir(locale as string)} className="h-40">
            <CommandGroup>
              {list?.map((item) => (
                <CommandItem
                  key={item.value}
                  value={item.value}
                  onSelect={(currentValue) => {
                    dispatch(
                      setSearchParams({
                        cityId: q?.cityId?.includes(currentValue)
                          ? q.cityId.filter(
                              (value: string) => value !== currentValue
                            )
                          : [...new Set([...(q.cityId || []), currentValue])],
                      })
                    );
                  }}
                >
                  {locale === "ar" ? item.label : item.value}
                  <Check
                    className={cn("size-4 opacity-0", {
                      "opacity-100": q?.cityId?.includes(item.value),
                    })}
                  />
                </CommandItem>
              ))}
            </CommandGroup>
          </ScrollArea>
        </CommandList>
      </Command>
    </FlexiblePopover>
  );
}
